import { newrelic } from "@jti/fe-clients";
import type { Product } from "@jti/magento";

import type { SummaryItem } from "../../ItemsSummaryView";
import { mapBundleProductToSummaryItem } from "../mapBundleProductToSummaryItem/mapBundleProductToSummaryItem";
import { mapSimpleProductToSummaryItem } from "../mapSimpleProductToSummaryItem/mapSimpleProductToSummaryItem";

export const mapProductToSummaryItem = (
  cartItem: Product,
  options: {
    isFreeTrial: boolean;
    displayBundleSelectedItems: boolean;
    displayBundleSelectedItemsPrices: boolean;
    showPricesWithTaxExcluded?: boolean;
  }
): SummaryItem | null => {
  switch (cartItem.type_id || cartItem.product_type) {
    case "simple":
      return mapSimpleProductToSummaryItem(cartItem, options.isFreeTrial, options.showPricesWithTaxExcluded);

    case "bundle":
      return mapBundleProductToSummaryItem(
        cartItem,
        options.displayBundleSelectedItems,
        options.displayBundleSelectedItemsPrices,
        options.showPricesWithTaxExcluded
      );

    default:
      newrelic.noticeError(new Error(`Unknown cart item type: ${cartItem.type_id}`));
      return null;
  }
};
